import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Badge, Button, Grid, MenuItem, Popover, Stack, Tab, Tabs, TextField, Typography } from "@mui/material";

import Appartement from "./Appartement";
import Maison from "./Maison";
import Terrain from "./Terrain";
import Lot from "./Lot";
import Cellar from "./Cellar";
import Attic from "./Attic";
import Shop from "./Shop";
import Office from "./Office";
import Castle from "./Castle";
import Immeuble from "./Immeuble";
import Localisation3 from "../Common/Localisation3";
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

import { makeStyles } from "@mui/styles";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import Bien3 from "../RealEstate/Bien3";
const useStyles = makeStyles((theme) => ({}));

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}
export default function BienDescriptif({ upperState, tab }) {
	console.log("render BienDescriptif", upperState, tab);// upperState, upperState.other_assets, upperState.other_assets.length);
	const classes = useStyles();

	const [state, setState] = useState({ ...upperState });
	const [updatedState, setUpdatedState] = useState({ uid: upperState.uid, changes: false });

	const handleChange = (event) => {
		console.log("updated state", updatedState, event)
		setUpdatedState({ ...updatedState, [event.target.name]: event.target.value, changes: true });
	};
	const handleChangeLoc = (loc) => {
		//console.log(loc.center[0], loc.center[1]);
		setState({ ...state, loc: loc, has_loc: true, full_adr: loc.Label });
		setUpdatedState({ ...state, loc: loc, has_loc: true, full_adr: loc.Label, changes: true });
	};

	const handleSubmit = (out, cb_url) => {
		console.log("handleSubmit", out, upperState);
		if (updatedState.changes) {
			const requestOptions = {
				method: "POST",
				headers: { "Content-Type": "application/json" },

				body: JSON.stringify(updatedState),
			};

			fetch("/api/02454b98a17f4161b1ec248c2574a10a", requestOptions)
				.then((response) => {
					return response.json();
				})
				.then((res) => {
					switch (res.res) {
						case "ok":
							window.location.href = cb_url;
							//reset
							// if (out === 1) {
							// 	switch (upperState.mode) {
							// 		case "AM":
							// 			window.location.href = "/newdeala/" + upperState.deal_uid + "/0";
							// 			break;
							// 		case "VN":
							// 			window.location.href = "/newdealv/" + upperState.deal_uid + "/00";
							// 			break;
							// 	}
							// }
							// if (out === 2) {
							// 	if (newValue === 2) {
							// 		if (state.tunnel) {
							// 			location.href = location.href + "_3";
							// 		} else {
							// 			location.href = location.href.includes("&step=2") ? location.href : location.href + (location.href.includes("?") ? "" : "?") + "&step=2";

							// 		}
							// 	} else {
							// 		setUpdatedState({ uid: upperState.uid, changes: false });
							// 		setState({ ...state, ...res.pld });
							// 	}



							// }
							// if (out === 3) {
							// 	setTabValue(tabValue + 1);
							// }
							break;

						case "err":
							break;
						default:
							break;
					}
				});
		} else {
			window.location.href = cb_url;
		}
		// if (!updatedState.changes && out === 1) {
		// 	switch (upperState.mode) {
		// 		case "AM":
		// 			window.location.href = "/newdeala/" + upperState.deal_uid + "/0";
		// 			break;
		// 		case "VN":
		// 			window.location.href = "/newdealv/" + upperState.deal_uid + "/00";
		// 			break;
		// 	}
		// }
	};
	const handleTabChange = (event, newTabValue) => {
		//validate previous data
		console.log("handleTabChange", newTabValue);
		const cb_url = getNextUrl(upperState, state.tunnel, newTabValue);
		handleSubmit(2, cb_url);

		// if (state.tunnel) {
		// 	if (newValue === 2) {
		// 		// pour forcer l'url
		// 		if (!updatedState.changes) {
		// 			location.href = location.href + "_3";
		// 		}

		// 	} else {
		// 		setTabValue(newValue);
		// 	}
		// } else {

		// 	if (newValue === 2) {
		// 		// pour forcer l'url
		// 		if (!updatedState.changes) {
		// 			location.href = location.href.includes("&step=2") ? location.href : location.href + (location.href.includes("?") ? "" : "?") + "&step=2";
		// 		}
		// 	} else {
		// 		setTabValue(newValue);
		// 	}

		// }


	};

	const setTabFromProps = (tab) => {
		console.log("setTabFromProps", tab);
		switch (tab) {
			case "1":
				return 0;
				break;
			case "1_2":
				return 1;
				break;
			case "1_3":
				return 2;
				break;
			default:
				return 0

		}
	}

	function a11yProps(index) {
		return {
			id: `simple-tab-${index}`,
			"aria-controls": `simple-tabpanel-${index}`,
		};
	}


	const [tabValue, setTabValue] = useState(setTabFromProps(tab));

	const [anchorEl, setAnchorEl] = useState(null);

	const handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};
	useEffect(() => {

		const visible_gen = (state.adr && state.type);

		if (state.visible_gen !== visible_gen) {
			setState({ ...state, visible_gen: visible_gen })
		}
		if (state.visible_gen !== visible_gen) {
			setState({ ...state, visible_gen: visible_gen })
		}

		const visible_carac = Object.entries(state).filter((rec) => rec[0].endsWith("_fld")).length === 0
		if (state.visible_carac !== visible_carac) {
			setState({ ...state, visible_carac: visible_carac });
		}

	}, [state]);

	const open = Boolean(anchorEl);
	return (
		<div className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Tabs value={tabValue} onChange={handleTabChange} aria-label="real-estate-tabs">
						<Tab label={<Badge
							color="primary"
							variant="dot"
							invisible={state.visible_gen}
						>Général</Badge>
						} {...a11yProps(0)} />
						{(state.type !== null || updatedState.type !== undefined) && <Tab label={<Badge
							color="primary"
							variant="dot"
							invisible={state.visible_carac}
						>Caractéristiques</Badge>
						} {...a11yProps(1)} />}
						{(state.type !== null || updatedState.type !== undefined) && <Tab label={<Badge
							color="primary"
							variant="dot"
							invisible={!state.is_main || (state.is_main && state.pics.length > 0)}
						>{state.pics.length > 0 ? state.pics.length : ""} Photo{(state.pics.length > 1 || state.pics.length == 0) ? "s" : ""}</Badge>
						} {...a11yProps(2)} />}
						{false && (state.type !== null || updatedState.type !== undefined) && upperState.mode === "AM" && <Tab label={<Button variant="contained" onClick={() => {
							switch (upperState.mode) {
								case "AM":
									window.location.href = "/newdeala/" + upperState.deal_uid + "/2";
									break;
								case "VN":
									window.location.href = "/newdealv/" + upperState.deal_uid + "/2";
									break;
							}

						}}>Voir les vendeurs</Button>} {...a11yProps(3)} />}
					</Tabs>

					<TabPanel value={tabValue} index={1} sx={{ padding: 0 }}>
						{/*<SwitchType type={state.type} tabValue={tabValue} state={{ ...state, ...updatedState }} setUpperState={setUpperState} />*/}
						{updatedState.type === "APT" ||
							(state.type === "APT" && (
								<Appartement tabValue={tabValue} upperState={{ ...state, ...updatedState }} upperHandleChange={handleChange} />
							))}
						{updatedState.type === "HSE" ||
							(state.type === "HSE" && (
								<Maison tabValue={tabValue} upperState={{ ...state, ...updatedState }} upperHandleChange={handleChange} />
							))}
						{updatedState.type === "BLD" ||
							(state.type === "BLD" && (
								<Immeuble tabValue={tabValue} upperState={{ ...state, ...updatedState }} upperHandleChange={handleChange} />
							))}
						{updatedState.type === "LAND" ||
							(state.type === "LAND" && (
								<Terrain tabValue={tabValue} upperState={{ ...state, ...updatedState }} upperHandleChange={handleChange} />
							))}

						{updatedState.type === "LOT" ||
							(state.type === "LOT" && (
								<Lot tabValue={tabValue} upperState={{ ...state, ...updatedState }} upperHandleChange={handleChange} />
							))}
						{updatedState.type === "CLR" ||
							(state.type === "CLR" && (
								<Cellar tabValue={tabValue} upperState={{ ...state, ...updatedState }} upperHandleChange={handleChange} />
							))}
						{updatedState.type === "SHP" ||
							(state.type === "SHP" && (
								<Shop tabValue={tabValue} upperState={{ ...state, ...updatedState }} upperHandleChange={handleChange} />
							))}
						{updatedState.type === "OFC" ||
							(state.type === "OFC" && (
								<Office tabValue={tabValue} upperState={{ ...state, ...updatedState }} upperHandleChange={handleChange} />
							))}
						{updatedState.type === "CST" ||
							(state.type === "CST" && (
								<Castle tabValue={tabValue} upperState={{ ...state, ...updatedState }} upperHandleChange={handleChange} />
							))}

						{updatedState.type === "ATC" ||
							(state.type === "ATC" && (
								<Attic tabValue={tabValue} upperState={{ ...state, ...updatedState }} upperHandleChange={handleChange} />
							))}
						{state.type === undefined && (
							<Typography>Vous n'avez pas encore spécifié de type de bien (Appartement, maison...)</Typography>
						)}
					</TabPanel>
					<TabPanel value={tabValue} index={2}>
						<Bien3 upperState={state} />
					</TabPanel>
					<TabPanel value={tabValue} index={0}>
						<Stack spacing={1}>
							<Box sx={{ flexGrow: 1 }}>
								<Grid container spacing={1}>
									<Grid item xs="auto" style="min-width: 150px;" >
										<Box display="flex" justifyContent={"flex-start"} alignItems="center" style="height: 100%">
											<Box>
												<Typography variant="h5">Adresse</Typography>
											</Box>
										</Box>
									</Grid>
									<Grid item xs={12} sm={6} md={6}>
										<Box display="flex" justifyContent={"space-between"} alignItems="center" >
											<Box>
												{state.new_loc && <Localisation3 upperState={state} mode="ADR" upperSendLoc={handleChangeLoc} />}
												{!state.new_loc && <Typography variant="body1">{state.adr ? state.adr : <em>Pas d'adresse enregistrée</em>}</Typography>}
											</Box>
											<Box>
												{!state.mandate_signed && !state.new_loc && <Button variant="contained" onClick={() => { setState({ ...state, new_loc: true }) }}>{state.adr ? "Modifier" : "Préciser"}</Button>}
												{state.new_loc && <Button variant="contained" onClick={() => { setState({ ...state, new_loc: false, loc: undefined }) }}>Annuler</Button>}
											</Box>
										</Box>
									</Grid>
								</Grid>
							</Box>
							<Box sx={{ flexGrow: 1 }}>
								<Grid container spacing={1}>
									<Grid item xs="auto" style="min-width: 150px;">
										<Box display="flex" justifyContent={"flex-start"} alignItems="center" style="height: 100%">
											<Box>
												<Typography variant="h5">Type de bien</Typography>
											</Box>
										</Box>
									</Grid>
									<Grid item xs={12} sm={6} md={6}>
										{!state.type && <TextField
											id="type"
											name="type"
											select
											value={updatedState.type ? updatedState.type : state.type}
											onChange={handleChange}
											variant="outlined"
											size="small"
										//style="padding-left: 8px"
										>
											{false && state.type === null && (
												<MenuItem key={"NIL"} value={"NIL"}>
													Choisir
												</MenuItem>
											)}
											{state.types.map((option) => (
												<MenuItem key={option.c} value={option.c}>
													{option.d}
												</MenuItem>
											))}
										</TextField>}
										{state.type && state.type_descr}
									</Grid>
								</Grid>
							</Box>

							{state.is_main && <Box sx={{ flexGrow: 1 }}>
								<Grid container spacing={1}>
									<Grid item xs="auto" style="min-width: 150px;">
										<Typography variant="h5">Description du bien</Typography>
										<InfoIcon aria-haspopup="true"
											aria-owns={open ? 'mouse-over-popover' : undefined}
											onMouseEnter={handlePopoverOpen}
											onMouseLeave={handlePopoverClose}
											style="margin-top: 6px;"
										/>
										<Popover
											id="mouse-over-popover"
											sx={{
												pointerEvents: 'none',
											}}
											open={open}
											anchorEl={anchorEl}
											anchorOrigin={{
												vertical: 'bottom',
												horizontal: 'left',
											}}
											transformOrigin={{
												vertical: 'top',
												horizontal: 'left',
											}}
											onClose={handlePopoverClose}
											disableRestoreFocus
										>
											<Stack sx={{ p: 1 }}>
												<Typography>Vous devez renseigner ici une description détaillée du bien à vendre.</Typography>
												<Box sx={{ p: 1 }} display={"flex"} justifyContent="space-between" alignItems={"center"}>
													<Box>
														<WarningIcon color="primary" />
													</Box>
													<Box sx={{ p: 1 }}>
														<Typography>Attention, ce texte servira de descriptif dans l'annonce</Typography>
														<Typography>immobilière qui sera générée sur le site.</Typography>
													</Box>
												</Box>

											</Stack>
										</Popover>
									</Grid>
									<Grid item xs={12} sm={6} md={6}>
										<TextField
											id="descr"
											name="descr"
											value={updatedState.descr ? updatedState.descr : state.descr}

											multiline
											rows={6}
											defaultValue=""
											variant="outlined"
											fullWidth
											onChange={handleChange}
										/>
									</Grid>
									{false && Object.keys(upperState.other_assets).length > 0 && <Grid item xs={12} sm={6} md={6}>
										Vous avez d'autres biens aux adresses {
											Object.entries(upperState.other_assets).map(([key, val]) => <Typography display={"inline"} key={key}>{val.length} {key}{val.length > 1 ? "s" : null} </Typography>)
										}
										<Typography variant="h5">Voulez-vous rajouter la phrase suivante à la description ?</Typography>
										<Typography><em>{
											Object.entries(upperState.other_assets).map(([key, val]) => <Typography key={key}>au {key}: {Object.entries(val).map(([key, val]) => <Typography display="inline" key={key}>{val.length} {key} </Typography>)}{val.length > 1 ? "s" : null}</Typography>)
										}</em></Typography>
										<Button onClick={() => {
											handleChange(
												{
													target: {
														name: "descr",
														value: (updatedState.descr ? updatedState.descr : state.descr) + "\r\n ainsi que" +
															Object.entries(upperState.other_assets).map(([key, val]) => `\r\n au ${key}: ${Object.entries(val).map(([key, val], i) => { return ` ${val.length} ${key} ${i + 1 < Object.entries(val).length ? " et " : ""}` })}`)
													}
												})
										}
										}>Rajouter</Button>
									</Grid>}
								</Grid>
							</Box>}
						</Stack>

					</TabPanel>
				</Grid>
				<Grid item xs={12}>
					<Box display="flex" justifyContent="space-between" alignItems="center" style="margin-top: 10px;">
						<Box></Box>
						{(state.type || updatedState.type) && <Box>
							{false && tabValue > 0 && (
								<Button startIcon={<ArrowBackIosIcon />} variant="outlined" style="margin-right: 10px;"
									onClick={(e) => { handleTabChange(e, tabValue - 1); }}
								>
									{tabValue === 1 ? "Général" : "caractéristiques"}
								</Button>
							)}

							< Button
								variant="contained"

								onClick={() => {
									//	console.log(upperState.deal_uid);
									const url = getNextUrl(upperState, state.tunnel, tabValue + 1);
									if (state.tunnel === false) {
										if (tabValue === 2) {
											window.location.href = url;
										} else {
											handleSubmit(2, url);

										}
									} else {
										if (tabValue === 2) {
											window.location.href = url;
										} else {
											handleSubmit(2, url);

										}

									}
								}}
							>
								{updatedState.changes ? "valider" : "suivant"}
							</Button>

						</Box>}
					</Box>
				</Grid>
			</Grid>
		</div >
	);
}
const translateTab = (tab) => {
	switch (tab) {
		case 0:
			return "1";
			break;
		case 1:
			return "1_2";
			break;
		case 2:
			return "1_3";
			break;
		default:
			return "1";
	}
}
const getNextUrl = (upperState, tunnel, tabValue) => {
	console.log("getNextUrl", upperState, upperState.mode, tunnel, tabValue)
	var url;
	if (tunnel === false) {
		if (tabValue === 3) {
			switch (upperState.mode) {
				case "AM":
					url = "/7bac6cb9d6ee4d70b1315393725f3a34/" + upperState.deal_uid;
					break;
				case "VN":
					url = "/11d1355181ac4376a09980601b420617/" + upperState.deal_uid;
					break;
			}

		} else {
			console.log()
			// switch (upperState.mode) {
			// 	case "AM":
			url = "/dre0/" + upperState.uid + "/" + translateTab(tabValue);
			// 		break;
			// 	case "VN":
			// 		url = "/dre0/" + upperState.uid + "/" + (tabValue === 1 ? "1_2" : "1_3");
			// 		break;
			// }

		}
	} else {
		if (tabValue === 3) {
			switch (upperState.mode) {
				case "AM":
					url = "/newdeala/" + upperState.deal_uid + "/" + ((upperState.other_assets_uncomplete + upperState.main_asset_uncomplete > 0) ? "0" : "2");
					break;
				case "VN":
					url = "/newdealv/" + upperState.deal_uid + "/" + ((upperState.other_assets_uncomplete + upperState.main_asset_uncomplete > 0) > 0 ? "00" : "2");
					break;
			}

		} else {

			switch (upperState.mode) {
				case "AM":
					url = "/newdeala/" + upperState.uid + "/" + translateTab(tabValue);
					break;
				case "VN":
					url = "/newdealv/" + upperState.uid + "/" + translateTab(tabValue);
					break;
			}

		}


	}
	console.log("getNextUrl", url)
	return url;
}
